
export default {
  name: 'Card',
  props: {
    title: String
  }
};
